import React from "react";

export const isLoaderLoading: any = React.createContext('default value');